import * as React from 'react';

export const header = {
  heading: 'Contact Us'
};
export const richText1 = {
  id: 'ContactUs',
  html:
    '                <p>If you have additional questions, concerns, \n'
    + '               would like information about how customers with disabilities may access this Privacy and Security Statement \n'
    + '               in an alternative format, or would like to exercise your rights, \n'
    + '               you can call us at <a href="tel:1-800-466-3337">1-800-466-3337</a>, fax us at <a href="fax:1-877-959-9768">1-877-959-9768</a>,\n'
    + '               or reach us by email at <a href="mailto:Customer_Care@homedepot.com">CustomerCare@homedepot.com</a>. You can write to us at:  </p> \n'
    + '              <p><br/></p> \n'
    + '              <p>The Home Depot </p> \n'
    + '              <p>Attention: Privacy Official Customer Care </p> \n'
    + '              <p>2455 Paces Ferry Road Atlanta, GA 30339-4024</p> \n'
    + '              <p><br/></p> \n'
    + '              <p>Changes to this Privacy and Security Statement</p> \n'
    + '              <p>Effective Date: July 1, 2020</p> \n'
    + '              <p>Last Revision Date: April 5, 2021</p> \n'
    + '              <p><br/></p> \n'
    + '              <p>From time to time we may change our privacy policies. \n'
    + '              <p>We will notify you of any material changes to our Privacy and Security Statement by posting an updated copy on our website. \n'
    + '              Please check our website periodically for updates.</p>'

};
